export default __webpack_public_path__ + "static/media/soccer.62760c53.PNG";